enum NotificationChannelType {
    None = '',
    Email = 'Email',
    Sms = 'Sms',
}

export default NotificationChannelType;
